import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export const structureHasDuplicateIds = () => {
  const machineStructure = getMachineStructureNodeset();
  const ids = machineStructure.getRootNode().createIdsArrayFromOurNodeTree();

  const uniqueIds = new Set(ids);
  const logger = getLogger();
  logger.debug("ids length", ids.length);
  logger.debug("uniqueIds", uniqueIds.size);

  if (ids.length !== uniqueIds.size) {
    const duplicates = ids.filter(
      (id, index, arr) => arr.indexOf(id) !== index,
    );
    logger.debug("Duplicate IDs found", duplicates);
    return duplicates;
  }

  return [];
};
